import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModalModule, PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { ProcessamentosFichasNovoComponent } from './novo.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
    FormsModule,
    PoModalModule
  ],
  declarations: [ ProcessamentosFichasNovoComponent ]
})
export class ProcessamentoFichasNovoModule { }